import React, {Component} from 'react';
import {Input} from "reactstrap";

export class MultiSelectItem extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
    }


    handleOnChange(event) {
        if(this.props.readOnly){
            return;
        }

        this.props.onChange(event)
    }

    render() {
        return (
            <li>
                <label className="multi-select-item">
                    <Input type="checkbox" onChange={this.handleOnChange}
                           checked={this.props.checked}
                           name={this.props.itemName}
                           data-id={this.props.itemId}
                           readOnly={this.props.readOnly}
                    />
                    <p className="multi-select-item-name">{this.props.itemName}</p>
                </label>
            </li>
        )
    }
}
